<template>
    <div class="upload-container">
        <el-button :style="{background:color,borderColor:color}" icon="el-icon-upload" size="mini" type="primary" @click=" dialogVisible=true">
            图片 /MP3 / MP4
        </el-button>
        <el-dialog :visible.sync="dialogVisible" append-to-body>
            <el-upload
                    accept="image/*, audio/mp3, video/mp4"
                    :multiple="true"
                    :file-list="fileList"
                    :show-file-list="true"
                    :on-remove="handleRemove"
                    :before-upload="beforeUpload"
                    class="editor-slide-upload"
                    action="自定义上传路径"
                    :http-request='uploadFile'
                    drag>
                <i class="el-icon-upload"/>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传图片或MP3/MP4文件</div>
            </el-upload>
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </el-dialog>
    </div>
</template>

<script>
    // import { getToken } from 'api/qiniu'
    import oss from '../../../api/oss'

    export default {
        name: 'EditorSlideUpload',
        props: {
            color: {
                type: String,
                default: '#1890ff'
            }
        },
        data() {
            return {
                dialogVisible: false,
                listObj: {},
                fileList: []
            }
        },
        methods: {
            checkAllSuccess() {
                return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess)
            },
            handleSubmit() {
                const arr = Object.keys(this.listObj).map(v => this.listObj[v]);
                if (!this.checkAllSuccess()) {
                    this.$message('请等待所有文件上传成功 或 出现了网络问题，请刷新页面重新上传！')
                    return
                }
                this.$emit('successCBK', arr);
                this.listObj = {};
                this.fileList = [];
                this.dialogVisible = false
            },
            handleSuccess(response, file) {
                const uid = file.uid;
                const objKeyArr = Object.keys(this.listObj);
                for (let i = 0, len = objKeyArr.length; i < len; i++) {
                    if (this.listObj[objKeyArr[i]].uid === uid) {
                        this.listObj[objKeyArr[i]].url = response.url;
                        this.listObj[objKeyArr[i]].hasSuccess = true;
                        return
                    }
                }
            },
            handleRemove(file) {
                const uid = file.uid
                const objKeyArr = Object.keys(this.listObj)
                for (let i = 0, len = objKeyArr.length; i < len; i++) {
                    if (this.listObj[objKeyArr[i]].uid === uid) {
                        delete this.listObj[objKeyArr[i]]
                        return
                    }
                }
            },
            beforeUpload(file) {
                const fileRegx = /image|mp3|mp4|mpeg/;
                if (fileRegx.test(file.type)) {
                    const fileName = file.uid;
                    this.listObj[fileName] = {
                        hasSuccess: false,
                        uid: file.uid,
                        type: file.type
                    }
                } else {
                    this.$message.error('文件格式不正确')
                }
            },
            uploadFile (param) {
                oss.putUseBucketImg(param.file).then(response => {
                    this.handleSuccess(response, param.file);
                    // this.$emit('changeImg', response.url)
                }).catch(err => {
                    throw err
                })
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .editor-slide-upload {
        margin-bottom: 20px;
        /deep/ .el-upload--picture-card {
            width: 100%;
        }
    }
</style>
